import axios from 'axios';

const baseURL =
    process.env.REACT_APP_AUTH_API_URL || '/authref/v1.0';

const instance = axios.create(
    {
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    }
});

instance.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('admin-token');
        let hospital = null;
        try {
            hospital = JSON.parse(sessionStorage.getItem('hmsv2-hospital') || 'null');
        } catch {
            hospital = null;
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        config.headers.dbname = hospital?.dbName || '';

        return config;
    }, error => {
        return Promise.reject(error);
    }
);

export default instance;
